import { Link } from "react-router-dom";
import { GET_PARAMS, GET_POPUPS } from "../const/router";
import usePrepareLink from "../hooks/usePrepareLink";

export interface EmptyCarpetPlaceHolderProps {
  imgSrc: string;
  title: string;
  subTitle: string;
  secondSubTitle?: string;
  isHomeCarpet?: boolean;
  showHelpLink?: boolean;
}

const EmptyCarpetPlaceHolder = ({
  imgSrc,
  title,
  subTitle,
  isHomeCarpet = false,
  secondSubTitle = "",
  showHelpLink = false,
}: EmptyCarpetPlaceHolderProps) => {
  const advacnedSearchlink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.advancedSearch,
    },
    keepOldQuery: true,
  });

  return (
    <div
      style={{
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={imgSrc}
        loading="lazy"
        style={{ width: "170px", minWidth: "0px" }}
      />
      <div style={{ textAlign: "center" }}>
        <h1>{title}</h1>
        <p>{subTitle}</p>
        {secondSubTitle && (
          <>
            <br />
            <p>{secondSubTitle}</p>
          </>
        )}
        {showHelpLink && (
          <>
            <a
              href="https://www.motke.co.il/%D7%A2%D7%96%D7%A8%D7%94"
              target="_blank"
            >
              צריכים עזרה עם שליחת הצעת היכרות?
            </a>
          </>
        )}
        {isHomeCarpet && (
          <div
            className="gallery_prof_info status"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Link
              to={advacnedSearchlink}
              className="button"
              style={{ minWidth: "300px" }}
            >
              <div>להעדפות שלי</div>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyCarpetPlaceHolder;
